<template>
  <div class="d-flex" id="page-dashboard">
    <MainBarMenu />
    <div class="layout-content container-fluid">
      <HeadingUser title="Dashboard" />
      <div class="row mt-3 mt-md-5">
        <div class="col-12 mb-3 mb-md-5 text-center">
          <button 
            type="button"
            v-show="user.core_role_id != 6"
            class="btn btn-outline-secondary btn-lg mr-3"
            v-on:click="selectOption(1)"
          >
            <b>Permisos Sindicales</b>
          </button>
          <button 
            type="button"
            v-show="user.core_role_id == 2 || user.core_role_id == 8 || user.core_role_id == 6 || user.core_role_id == 4 || user.core_role_id == 9 || user.core_role_id == 10"
            class="btn btn-outline-secondary btn-lg ml-3"
            v-on:click="selectOption(2)"
            >
            <b>Derechos de petición</b>
          </button>          
        </div>
        <div class="col-12 mb-3 mb-md-5 text-left">
          <h3 class="mb-0">{{titleOption}}</h3>
        </div>
        <div class="col-12 mb-3 mb-md-5 text-center" v-if="flagComponent == 1">
          <DashboardPermisos />
        </div>
        <div class="col-12 mb-3 mb-md-5 text-center" v-if="flagComponent == 2">
          <div style="width: 300px">
            <DashboardDerechos />
          </div>

        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
      <div class="mb-menu"></div>
    </div>
    <!-- .layout-content -->
  </div>
  <!-- #page-dashboard -->
</template>

<script>
import { mapState } from "vuex";
import serverConfig from "./../../services/config";
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";

import DashboardPermisos from "./DashboardPermisos";
import DashboardDerechos from "./DashboardDerechos";

export default {
  name: "Dashboard",
  components: {
    DashboardPermisos,
    DashboardDerechos,
    MainBarMenu,
    HeadingUser,
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      laborUnion: 1,
      flagComponent: 1,
      titleOption: 'Dashboard de Permisos Sindicales'
    };
  },
  beforeMount() {
    if(this.user.core_role_id == 6){
      this.selectOption(2)
    }    
  },
  computed: {    
    ...mapState("modCore", ["user"]),    
  },
  methods: {
    selectOption(id){
      if(id == 1){
        this.titleOption= 'Dashboard de Permisos Sindicales';
        this.flagComponent = id;
      }
      if(id == 2){
        this.titleOption= 'Dashboard de Derechos de Petición';
        this.flagComponent = id;
      }
    },
  },
};
</script>

<style lang="scss">
#page-dashboard {
  .cont-title {
    h3 {
      color: #1c3a4e;
      font-size: 12px;
      line-height: 22px;

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 20px;
      }
    }

    .icon {
      color: #1c3a4e;
      font-size: 18px;

      @media (min-width: 768px) {
        font-size: 22px;
      }
    }
  }

  .cont-chart {
    .chart-select {
      border: 0 none;
      color: #303030;
      font-weight: 500;
      outline: none;

      &:focus {
        outline: none;
      }
    }
  }

  .cont-doughnut-chart {
    .cont-txt {
      color: #303030;
      width: 126px;
      height: 120px;
      top: calc(50% - 60px);
      left: calc(50% - 63px);

      .title {
        font-size: 14px;
        margin-bottom: 0;
      }
      .number {
        font-size: 40px;
        line-height: 40px;
        font-weight: bold;
        margin-bottom: 0;
        padding: 10px 0;
      }

      .cont-desc {
        font-size: 12px;
        p {
          margin-bottom: 0;
        }
      }
    }
  }

  .cont-permisions {
    color: #303030;
    .number {
      font-size: 28px;
      font-weight: bold;

      @media (min-width: 768px) {
        font-size: 48px;
      }
    }
    .txt {
      font-size: 14px;
      line-height: 16px;

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
}
</style>